import React from "react";
import { createRoot } from "react-dom/client";
import { Carousel } from "./comp-carousel";
export const CarouselLoader = (carousels) => {
    carousels.forEach((element) => {
        var _a;
        const externalContainerId = element.getAttribute("data-target");
        if (!externalContainerId) {
            throw new Error("Carousel data-target attribute is missing");
        }
        const externalContainer = document.getElementById(externalContainerId);
        if (!externalContainer) {
            throw new Error(`Carousel data-target attribute is invalid: ${externalContainerId}`);
        }
        let stepSize = 1;
        const stepData = element.getAttribute("data-step");
        if (stepData) {
            stepSize = JSON.parse(stepData);
        }
        let ctaLabelAttr = element.getAttribute("data-cta-label");
        let ctaHrefAttr = element.getAttribute("data-cta-href");
        let ctaTypeAttr = (_a = element.getAttribute("data-cta-type")) !== null && _a !== void 0 ? _a : "link";
        let ctaLabel = undefined;
        let ctaHref = undefined;
        let ctaType = undefined;
        if (ctaLabelAttr !== null && ctaHrefAttr !== null) {
            ctaLabel = ctaLabelAttr;
            ctaHref = ctaHrefAttr;
            if (ctaTypeAttr === "link" || ctaTypeAttr === "button") {
                ctaType = ctaTypeAttr;
            }
        }
        let root = createRoot(element);
        // Wait for the externalContainer to be visible via IntersectionObserver
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.target === externalContainer) {
                    if (entry.isIntersecting) {
                        root.render(React.createElement(Carousel, { externalContainer: externalContainer, stepSize: stepSize, ctaType: ctaType, ctaLabel: ctaLabel, ctaHref: ctaHref }));
                    }
                }
            });
        });
        observer.observe(externalContainer);
    });
};
